import { CameraFeature } from '../features/camera/camera.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class CameraLayerRenderer extends StandardLayerRenderer {
  protected Feature = CameraFeature;
}
